<template>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Testo" text="Testo"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.text" />
    </div>
    <div class="form-group">
        <label class="form-label small mb-1">
            <localized-text localizedKey="Href" text="Href"></localized-text>
        </label>
        <input class="form-control" type="text" v-model="localValue.href" />
    </div>
</template>

<script lang="ts">
import * as OM from '@/model';
import { Options } from 'vue-class-component';
import { Mixins, Watch } from 'vue-property-decorator';
import WithModel from '@/mixins/withModel';

@Options({})
export default class routerButtonBlock extends Mixins(WithModel) {
    declare localValue: OM.RouterButtonBlock;

    created(){
        if(!this.localValue.text){
            this.localValue.text = "";
        }
        if(!this.localValue.href){
            this.localValue.href = "";
        }
    }

    @Watch('localValue.isFullWidth')
    @Watch('localValue.marginBottom')
    @Watch('localValue.text')
    @Watch('localValue.href')
    onChange(){
        this.localValue.htmlText = `
            <div class="routerButtonBlock text-center ${(!this.localValue.isFullWidth ? 'px-4' : '')} ${('mb-' + this.localValue.marginBottom)}">
                <a class="btn btn-primary" href="${this.localValue.href}">
                    ${this.localValue.text}
                </a>
            </div>
        `;
    }

}
</script>
